module.exports = __webpack_public_path__ + "static/Ransom-Brothers-Lumber-Supply-532-B-St-Ramona-CA-92065-2982fe7e7106664b5d15d50001923b71.jpg";